<template lang="pug">
  transition(name="fade")
    #home
      .input(v-show="showInput")
        .title Avatar Generator
        p upload a face image to begin
        .btns
          label(for="face_image" class="btn btn-info") Choose file
          input(
            accept="image/*"
            type="file"
            id="face_image"
            name="face_image"
            @change="onFileSelect"
            single
          )
        .output
          //.label(ref = "input_label") {{input_label}}
          .output_img_parent
            img(class="input_thumb", ref = "input_thumb")
            face-geo
        .btns
          .btn( v-if="showNext" @click="onNextClick" ) Next

      .wait( v-if="showWait" ) Wait...

      .output-all(v-show="!showInput")
        .output-images
          face-asset-comp.face-asset-comp
          face-geo-upright.face-geo-upright-image( mode='image')
          face-geo-upright.face-geo-upright-geo( mode='shapes')

        .scroll-data
          face-asset-list
          face-feature-list-grouped





</template>

<script>
  import {
    MODAL_STATES,
    PATHS,
    APP_NAME,
    GETTERS,
    ACTIONS,
    MUTATIONS,
    STATES
  } from 'src/config/app'
  import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
  import { TweenLite } from 'gsap'
  import {EVENTS, STATE, default as FaceFeatureService} from "src/services/FaceFeatureService/FaceFeatureService"
  import FaceGeo from "src/services/FaceFeatureService/vue/face_geo.vue"
  import FaceAssetList from "src/services/FaceFeatureService/vue/face_asset_list.vue"
  import FaceFeatureListGrouped from "src/services/FaceFeatureService/vue/face_feature_list_grouped.vue"
  import FaceAssetComp from "src/services/FaceFeatureService/vue/face_asset_comp.vue"
  import FaceGeoUpright from "src/services/FaceFeatureService/vue/face_geo_upright.vue"

  export default {
    name: 'home',
    components: {
      FaceGeo,
      FaceAssetList,
      FaceFeatureListGrouped,
      FaceAssetComp,
      FaceGeoUpright
    },
    data() {
      return {
        input_label:"",
        file_name:"",
        has_image:false,
        base64_data:{},
        data_state:STATE.NO_DATA,
        hasFaceInformation:false,
      }
    },
    computed: {
      ...mapState(APP_NAME, [
        STATES.loading,
        STATES.modal_state,
        STATES.app_state,
      ]),

      showInput(){return !this.hasFaceInformation},

      showNext(){return this.has_image && (this.data_state === STATE.NO_DATA)},
      showWait(){return (this.data_state === STATE.WAITING) }
    },
    mounted() {
      FaceFeatureService.on(EVENTS.state, (state)=>{this.data_state = state})
      FaceFeatureService.on(EVENTS.faceInfo, this.onFaceInfo)
    },
    beforeDestroy() {
      FaceFeatureService.off(EVENTS.state, (state)=>{this.data_state = state})
      FaceFeatureService.off(EVENTS.faceInfo, this.onFaceInfo)
    },
    methods: {
      ...mapMutations(APP_NAME, [
        MUTATIONS.setAppState,
        MUTATIONS.setModalState
      ]),

      onFaceState(state) {
        this.data_state = state
      },

      onFaceInfo(state) {
        this.hasFaceInformation = !!state
      },

      onFileSelect(evt) {
        this.fileSelect(evt.target.files[0]);
      },

      fileSelect(file){
        this.has_image = false;
        this.file_name = escape(file.name);
        var reader = new FileReader();

        reader.onload = (e)=> {
            if(reader.readyState == FileReader.DONE) {
             this.onInputFile(e.target.result)
          }
        }
        reader.readAsDataURL(file);
      },


      resizeToMax(data_url, w = 512,h = 512, callback){
        const outputCanvas = document.createElement('canvas');
        const canvasContext = outputCanvas.getContext('2d');

        const img = new Image();

        img.onload = function() {
          let newWidth=img.width, newHeight=img.height;

          if (img.width > w || img.height > h){
            if (img.width > img.height) {
              newWidth = w;
              newHeight = (img.height * w) / img.width;
            } else {
              newHeight = h;
              newWidth = (img.width * h) / img.height;
            }
          }
          outputCanvas.width = newWidth;
          outputCanvas.height = newHeight;
          canvasContext.drawImage(img, 0, 0, newWidth, newHeight);

          const imageDataURL = outputCanvas.toDataURL('image/png');
          callback(imageDataURL);

          // The resized image is now drawn on the canvas
        };

        img.src = data_url //URL.createObjectURL(file);
      },


      onInputFile(data_url) {
        this.resizeToMax(data_url,600,600,(data_url)=>this.setDataUrl(data_url))
      },

      setDataUrl(data_url){
        var prefix = ';base64,';
        var idx = data_url.indexOf(prefix);
        if (idx >= 0) {
          this.base64_data = data_url.substring(idx + prefix.length);
          this.has_image = true;
          this.$refs["input_thumb"].setAttribute("src", data_url )
          this.data_url = data_url
          this.input_label = this.file_name;
          FaceFeatureService.setFaceInfo(null)
        }
      },

      onNextClick(){
        //this.goPath(PATHS.DETECTION)
        let h = this.$refs["input_thumb"].naturalHeight
        let w = this.$refs["input_thumb"].naturalWidth
        FaceFeatureService.uploadImage(this.file_name, this.data_url, w, h, );
      },

      goPath(path) {
        this.setAppState(path)
      },
    },
    watch: {},
  }
</script>

<style lang="sass" scoped>
  @import "src/styles/base.sass"
  @import "src/styles/common.sass"

  #home
    +full()
    +flex-center()
    text-align: center

    .output-all

      .desktop &
        pointer-events: none
        position: absolute
        top: 0px
        left: 0px
        width: 100%
        height: 100%

      .mobile &
        display: block
        position: absolute
        top: 0px
        left: 0px
        width: 100%
        height: 100%
        overflow-x: hidden
        overflow-y: scroll



    .output-images
      display: block

      .desktop &
        text-align: left
        position: absolute
        top: 0px
        left: 0px
        width: calc(100% - 380px)
        height: 100%

      .mobile &
        text-align: center
        position: relative


    .face-asset-comp
      display: inline-block
      position: relative
      margin-right: 4px

    .face-geo-upright-image
      display: inline-block
      position: relative
      margin-right: 4px

    .face-geo-upright-geo
      display: inline-block
      position: relative


    .scroll-data

      .desktop &
        z-index: 1
        pointer-events: auto
        display: block
        position: absolute
        top: 0px
        right: 0px
        width: 375px
        height: 100%
        overflow-x: hidden
        overflow-y: scroll
        height: 100%

      .mobile &
        display: block
        position: relative
        width: 100%

    .wait
      +full()
      +flex-center()
      background-color: rgba(255,255,255,0.5)


    .title
      +BodyFont()
      position: relative
      display: block
      font-size: 35px
      margin-bottom: 20px

    .h2
      +BodyFont()
      position: relative
      display: block
      font-size: 20px
      margin-bottom: 20px

    .input_thumb
      height: 400px
      width: auto

    .output
      margin-top: 20px
      background-color: #cccccc
      min-width: 100px

    .output_img_parent
      font-size: 0px
      display: block
      position: relative

    .btns
      position: relative
      display: block
      width: 100%
      text-align: center
      //+flex-center()

      margin-top: 20px
      margin-left: -20px

      input[type="file" ]
        width: 0.1px
        height: 0.1px
        opacity: 0
        overflow: hidden
        position: absolute
        z-index: -1


    .btn
      +BodyFont()
      color: white
      font-size: 15px
      line-height: 40px
      background-color: dodgerblue
      border-radius: 10px
      border: 0px solid rgba(0,0,0,0)
      position: relative
      display: inline-block
      margin-left: 20px
      padding-left: 20px
      padding-right: 20px



</style>
